/* eslint-disable no-shadow */
const state = {
    items: [],
    starred: [],
    answered_careers: [],
};

const actions = {
    addStar({ commit }, item) {
        commit('addStar', item);
    },
    addAnsweredCareer({ commit }, item) {
        commit('addAnsweredCareer', item);
    },
    cleanAnsweredCareer({ commit }) {
        commit('cleanAnsweredCareer');
    },
};

const mutations = {
    addStar(state, item) {
        state.starred.push(item);
    },
    addAnsweredCareer(state, item) {
        state.answered_careers.push(item);
    },
    cleanAnsweredCareer(state) {
        state.answered_careers = [];
    },

};

const getters = {
    answered_careers: storeState => storeState.answered_careers,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
